<template>
  <div class="text-icon-tile">
    <span class="icon" :style="{fontSize: fontSize+'px'}" :icon="icon">
      <i :class="`mdi mdi-${icon}`">

      </i>
    </span>
    
    <div :style="{fontSize: fontSize+'px'}" class="icon-title">{{ $t(title) }}</div>
    
  </div>
</template>

<script>
export default {
  name: 'TextIconTile',
  props: {
    icon: {
      type: String,
      required: true
    },
    fontSize: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.text-icon-tile {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  justify-content: center;
  align-content: center;
  height: 100%;
}  
.text-icon-tile > * {
  width: 100%;
  line-height: 1.4em;
  margin: 0 !important;
}


</style>